import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generalTree } from '@/api/general';
export default {
  name: 'Index',
  props: {
    treeUrl: {
      type: String,
      default: null
    },
    treeKey: {
      type: String,
      default: 'value'
    },
    treeLabel: {
      type: String,
      default: 'label'
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    treeCheckedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      treeData: [],
      filterText: '',
      filterIndex: 0,
      defaultProps: {
        children: 'children',
        label: this.treeLabel
      },
      expandAll: false,
      valueArr: [],
      loading: false,
      currentNode: {}
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.GeneralSelectTree.filter(val);
    },
    treeData: function treeData(val) {
      var _this = this;
      //console.log('treeData')
      //console.log(val)
      if (val && val.length <= 10) {
        this.valueArr = [];
        this.treeData.forEach(function (m) {
          _this.valueArr.push(m.value);
          if (m.children && m.children.length <= 5) {
            m.children.forEach(function (n) {
              _this.valueArr.push(n.value);
            });
          }
        });
        //console.log(this.valueArr)
        //console.log(this.treeCheckedKeys)
        if (this.treeCheckedKeys && this.treeCheckedKeys.length > 0) {
          this.treeCheckedKeys.forEach(function (v) {
            return _this.valueArr.push(v);
          });
        }
        this.$nextTick(function () {
          if (_this.treeCheckedKeys != null) {
            _this.$refs.GeneralSelectTree.setCurrentKey(_this.treeCheckedKeys[0]);
          }
        });
      }
    },
    treeCheckedKeys: function treeCheckedKeys(val) {
      // console.log('val')
      // console.log(val)
    }
  },
  created: function created() {
    // console.log('created')
  },
  methods: {
    getTreeData: function getTreeData() {
      var _this2 = this;
      // console.log('getTreeData')
      //  this.treeData = []
      this.filterText = '';
      this.loading = true;
      return new Promise(function (resolve, reject) {
        generalTree(_this2.treeUrl).then(function (response) {
          _this2.treeData = response.data.data;
          // this.$parent.$parent.handleTreeDataLoaded(this.treeData)
          // console.log('getTreeData2')
          if (response.data.code !== '0') {
            _this2.$notify({
              title: _this2.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          //console.log('getTreeData3')
          _this2.loading = false;
          //console.log(response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this2.loading = false;
          reject(error);
        });
      });
    },
    // filterNode(value, data) {
    //   if (!value) return true
    //   return data[this.treeLabel].indexOf(value) !== -1
    // },
    filterNode: function filterNode(value, data, node) {
      if (!value) {
        return true;
      }
      this.filterIndex = 0;
      var level = node.level;
      var _array = []; //这里使用数组存储 只是为了存储值。
      this.getReturnNode(node, _array, value);
      var result = false;
      _array.forEach(function (item) {
        result = result || item;
      });
      return result;
    },
    getReturnNode: function getReturnNode(node, _array, value) {
      var isPass = node.data && node.data.label && node.data.label.indexOf(value) !== -1;
      isPass ? _array.push(isPass) : '';
      this.filterIndex++;
      //console.log(this.filterIndex)
      if (!isPass && node.level != 1 && node.parent) {
        this.getReturnNode(node.parent, _array, value);
      }
    },
    handleNodeClick: function handleNodeClick(obj, node, component) {
      //console.log(obj[this.treeKey])
      this.currentNode = node;
      if (!this.isMultiple) {
        var result = [];
        result.push(obj[this.treeKey]);
        this.$refs.GeneralSelectTree.setCheckedKeys(result);
      }
      //this.$parent.$parent.handleTreeNodeClick(obj[this.treeKey])
    }
  }
};